import React from 'react';
import styled from 'styled-components';

import ModalLogo from '../Template/Images/logo_black.svg';

const Container = styled.div`
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: ${props => props.modal ? "flex" : "none"};
  justify-content: center;
  align-items: center;
  padding: 0 20px;
`

const Modal = styled.div`
  position: relative;
  z-index: 200;
  margin-bottom: 80px;
  background-color: #fff;
  width: 400px;
  height: 320px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 20px;
  
  & > img {
    margin-top: auto;
    width: 120px;
  }
  & > p:nth-child(2) {
    margin-top: 40px;
    font-size: 19px;
    font-weight: 500;
  }
  & > p:nth-child(3) {
    margin-top: 15px;
    font-size: 15px;
    line-height: 160%;
    text-align: center;
    font-weight: 300;
  }
  & > button {
    margin-top: auto;
    margin-bottom: 20px;
    height: 40px;
    width: 100%;
    border-radius: 5px;
    background-color: #000;
    font-size: 15px;
    color: #fff;
    cursor: pointer;
  }

  @media (max-width: 400px) {
    width: 100%;
  }
`

const BgBlack = styled.div`
  position: absolute;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.4;
`


export default ({ modal }) => {
  return (
    <Container modal={modal.value}>
      <Modal>
        <img alt="" src={ModalLogo} />
        <p>등록이 완료되었습니다.</p>
        <p>문의하신 내용은 빠른 시일 안으로<br/>답변드리도록 하겠습니다.</p>
        <button onClick={() => { modal.setValue(!modal.value)}}>확인</button>
      </Modal>
      <BgBlack />
    </Container>
  )
}